import React, { useState } from "react";
import "../../css/UniversityPlacements.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const UNIVERSITIES = [
  "National University of Singapore",
  "Nanyang Technological University",
  "University of Oxford",
  "University of Cambridge",
  "Imperial College London",
  "Carnegie Mellon University",
  "UCLA",
  "Georgia Tech",
  "London School of Economics",
];

const COUNTRIES = [
  { flag: "🇺🇸", name: "United States" },
  { flag: "🇬🇧", name: "United Kingdom" },
  { flag: "🇭🇰", name: "Hong Kong" },
  { flag: "🇸🇬", name: "Singapore" },
];

const FAQ_ITEMS = [
  {
    q: "Do Sahara Public School graduates get into top universities?",
    a: "Yes, our graduates are regularly accepted into leading universities worldwide thanks to strong academics, career guidance, and well-rounded credentials.",
  },
  {
    q: "What kind of university support does the school offer?",
    a: "Students get one-on-one counselling, help with applications, and access to university fairs and information sessions held right on campus.",
  },
  {
    q: "Does the school help with essays and recommendation letters?",
    a: "Yes, students receive guidance on preparing transcripts, recommendation letters, essays and personal statements needed for top-tier university applications.",
  },
];

export default function UniversityPlacements() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="up-page">
      {}
      <SchoolHero
        title="University Placements"
        
        subtitle="World-Class Infrastructure"
        image="/images/up.jpeg"
      />
      <section className="up-hero">
        <h1>University Placements</h1>
        <p>
          Our graduates are sought after by leading universities every year,
          thanks to their all-round credentials and strong results.
        </p>
      </section>

      {}
      <section className="wrap up-intro">
        <p>
          Every year, Grade 12 students from Sahara Public School graduate with
          university acceptance letters in hand, going on to study at some of
          the world's most respected institutions.
        </p>
      </section>

      {}
      <section className="up-universities">
        <div className="wrap">
          <h2>Where Our Graduates Go</h2>
          <div className="up-uni-list">
            {UNIVERSITIES.map((u) => (
              <span className="up-uni-chip" key={u}>
                {u}
              </span>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap up-feature">
        <div className="up-feature-icon">
          <span className="emoji-badge">🎓</span>
        </div>
        <div>
          <h2>University Connect</h2>
          <p>
            Every year, universities from around the world hold student-centric
            events on our campus, giving students and parents a chance to
            connect directly and explore programmes that fit their goals.
          </p>
          <p>
            Our support includes one-on-one counselling, career fairs,
            information sessions, university visits, and expert guidance
            throughout the application process.
          </p>
        </div>
      </section>

      {}
      <section className="wrap up-feature reverse">
        <div>
          <h2>Career Counselling</h2>
          <p>
            Students receive detailed career counselling, with our counsellors
            studying each student's performance before recommending suitable
            universities during personal sessions with parents and students.
          </p>
          <p>
            Once a university is finalised, students are guided step by step
            through the entire application process, including help with
            transcripts, essays, and personal statements.
          </p>
        </div>
        <div className="up-feature-icon">
          <span className="emoji-badge">🧭</span>
        </div>
      </section>

      {}
      <section className="up-countries-section">
        <div className="wrap">
          <h2>Popular Countries for Higher Education</h2>
          <div className="up-countries-grid">
            {COUNTRIES.map((c) => (
              <div className="up-country-card" key={c.name}>
                <span className="flag">{c.flag}</span>
                {c.name}
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <section className="wrap up-faq">
        <h2>Frequently Asked Questions</h2>
        {FAQ_ITEMS.map((item, idx) => {
          const isOpen = openFaq === idx;
          return (
            <div className="faq-mini-item" key={item.q}>
              <button
                type="button"
                className="faq-mini-question"
                onClick={() => setOpenFaq(isOpen ? -1 : idx)}
              >
                <span>{item.q}</span>
                <span>{isOpen ? "−" : "+"}</span>
              </button>
              {isOpen && <p className="faq-mini-answer">{item.a}</p>}
            </div>
          );
        })}
      </section>
    </div>
  );
}
